"use strict";
// src/graphql/fetchData.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchNftHolders = exports.fetchAutoCompoundingEventsGql = void 0;
exports.fetchUserWalletData = fetchUserWalletData;
exports.fetchProtocolData = fetchProtocolData;
exports.fetchPortfolioData = fetchPortfolioData;
exports.fetchChainIdentifier = fetchChainIdentifier;
exports.fetchUserVaults = fetchUserVaults;
exports.fetchUserVaultBalances = fetchUserVaultBalances;
exports.fetchPools = fetchPools;
exports.fetchCetusPools = fetchCetusPools;
const tslib_1 = require("tslib");
/* This file will contain functions that use the Apollo Client to
/* execute the queries and return data.
 */
const client_js_1 = tslib_1.__importDefault(require("./client.js"));
const queries_js_1 = require("./queries.js");
async function fetchUserWalletData(address) {
    const { data } = await client_js_1.default.query({
        query: queries_js_1.GET_USER_WALLET_DATA,
        variables: { address },
    });
    return data?.userWallet;
}
async function fetchProtocolData() {
    const { data } = await client_js_1.default.query({
        query: queries_js_1.GET_PROTOCOL_DATA,
    });
    return data?.protocolData;
}
async function fetchPortfolioData(address) {
    const { data } = await client_js_1.default.query({
        query: queries_js_1.GET_PORTFOLIO_DATA,
        variables: { address },
    });
    return data?.portfolio;
}
async function fetchChainIdentifier() {
    const { data } = await client_js_1.default.query({
        query: queries_js_1.GET_CHAIN_IDENTIFIER,
    });
    return data?.chainIdentifier;
}
async function fetchUserVaults(walletAddress) {
    const { data } = await client_js_1.default.query({
        query: queries_js_1.GET_USER_VAULTS,
        variables: {
            address: walletAddress,
        },
    });
    return data?.address;
}
async function fetchUserVaultBalances(walletAddress) {
    const { data: poolsData } = await client_js_1.default.query({
        query: queries_js_1.GET_POOLS,
    });
    const { data: cetusPoolsData } = await client_js_1.default.query({
        query: queries_js_1.GET_CETUS_POOLS,
    });
    const { data: investorsData } = await client_js_1.default.query({
        query: queries_js_1.GET_INVESTORS,
    });
    const { data: userVaultBalancesData } = await client_js_1.default.query({
        query: queries_js_1.GET_USER_VAULT_BALANCES,
        variables: {
            address: walletAddress,
        },
    });
    const data = {
        ...(poolsData ?? {}),
        ...(cetusPoolsData ?? {}),
        ...(investorsData ?? {}),
        ...(userVaultBalancesData ?? {}),
    };
    return data;
}
async function fetchPools() {
    const { data } = await client_js_1.default.query({
        query: queries_js_1.GET_POOLS,
    });
    return data ?? {};
}
async function fetchCetusPools() {
    const { data } = await client_js_1.default.query({
        query: queries_js_1.GET_CETUS_POOLS,
    });
    return data ?? {};
}
var fetchAutoCompoundingEventsGql_js_1 = require("./fetchAutoCompoundingEventsGql.js");
Object.defineProperty(exports, "fetchAutoCompoundingEventsGql", { enumerable: true, get: function () { return fetchAutoCompoundingEventsGql_js_1.fetchAutoCompoundingEventsGql; } });
var fetchNftHolders_js_1 = require("./fetchNftHolders.js");
Object.defineProperty(exports, "fetchNftHolders", { enumerable: true, get: function () { return fetchNftHolders_js_1.fetchNftHolders; } });
// Add more functions for other data fetching requirements
//# sourceMappingURL=fetchData.js.map